module.exports = __webpack_public_path__ + "img/item-study.2eb84f5f.svg";